import React, { ReactNode, FC } from 'react';
import AppBar from '@mui/material/AppBar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';

type TopPropsType = {
    draverWidth: number;
    handleDrawerToggle: React.MouseEventHandler<HTMLButtonElement>;
    children: ReactNode;
};

const TopContainer: FC<TopPropsType> = (props) => {
    return (
        <AppBar
            position="fixed"
            sx={{
                width: { sm: `calc(100% - ${props.draverWidth}px)` },
                ml: { sm: `${props.draverWidth}px` },
            }}
        >
            <Toolbar>
                <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    edge="start"
                    onClick={props.handleDrawerToggle}
                    sx={{ mr: 2, display: { sm: 'none' } }}
                >
                    <MenuIcon />
                </IconButton>
                {props.children}
            </Toolbar>
        </AppBar>
    );
};

export default TopContainer;
